<div class="row justify-content-center">
  <div class="col-lg-5">
    <div class="text-center mb-4">
      <h4 class="fw-bold">Sign in</h4>
      <p>Don't have an account yet?
        <a [routerLink]="['/account/signup']" class="link-dark text-decoration-none fw-bold">
          Sign up here
        </a>
      </p>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="submit()" novalidate>

      <div class="form-group mb-3">
        <label class="form-label" for="email">Your Email</label>
        <input type="email" class="form-control" MyInput placeholder="Email" formControlName="email" id="email">
        <my-error controlName="email" errorKey="required">Email is required.</my-error>
        <my-error controlName="email" errorKey="email">Please enter a valid email.</my-error>
      </div>
      <div class="form-group mb-3">
        <label class="form-label d-flex justify-content-between align-items-center" for="password">
          <span>Password</span>
          <a class="link-primary text-decoration-none" [routerLink]="['/account/forgot-password']">Forgot Password?</a>
        </label>
        <input type="password" class="form-control" MyInput formControlName="password" id="password"
          placeholder="********">
        <my-error controlName="password" errorKey="required">Password is required.</my-error>
      </div>
      <div class="form-group mb-3">
        <button class="btn btn-primary btn-lg btn-block mt-3" [disabled]="!loginForm.valid || loading" type="submit">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
          Sign In
        </button>
      </div>
    </form>
  </div>
</div>